const selectError = (state) => state.errors.error;

export default {selectError};